export enum MyLiNKTab {
    BookmarksAndCollections = 1,
}
